module.exports = __webpack_public_path__ + "img/redPacket.21f61e39.png";